
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/implementation-checklist",
      function () {
        return require("private-next-pages/core-exchange/docs/implementation-checklist/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/implementation-checklist"])
      });
    }
  